import React, { useEffect, useRef } from "react";
import { Wrapper } from "../../../constants/common/StyledGlobalConstants";
import styled from "styled-components";
import { getPendoId } from "../../../util/cfstPendoUtils";
import PropTypes from "prop-types";

const CustomWrapper = styled(Wrapper)`
  width: auto;
  height: 40px;
  color: #0077b4;
  cursor: pointer;
  font-family: neue-haas-grotesk-display;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1rem;
  padding: 0.75rem 0rem;
  text-align: center;
  text-transform: uppercase;
  background: transparent;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0.25rem;
  padding: 12px 16px;

  & span {
    padding: 12px 16px;
    text-overflow: unset;
  }

  &:hover {
    color: #0077b4;
    background: #ceeeff;
    border: 0;
  }
  &:active,
  &:active:focus {
    color: #0077b4;
    background: #7bbce1 !important;
    outline: none !important;
    border: 0;
  }
  &:focus {
    color: #0077b4;
    background: #ffffff;
    outline: 2px solid #0077b4 !important;
  }
  &:before {
    border: none !important;
    outline: none !important;
  }
`;

const TryAgain = ({ padding, handleClick }) => {
  const messageRef = useRef(null);

  useEffect(() => {
    if (messageRef.current) {
      messageRef.current.focus();
    }
  }, []);

  return (
    <Wrapper display="flex" flexDirection="column" padding={padding || "15.438rem 0rem"} alignItems="center" width="100%">
      <Wrapper lineHeight="1.25rem" fontSize="0.875rem" fontWeight="700" color="#222222" tabIndex="-1" aria-hidden="true">
        Something went wrong.
      </Wrapper>
      <CustomWrapper
        id={getPendoId("try-again-button")}
        onClick={handleClick}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleClick()}
        ref={messageRef}
        aria-live="assertive"
        role="alert"
        tabIndex="0"
        aria-label="Something went wrong. Click to activate. Try again"
      >
        TRY AGAIN
      </CustomWrapper>
    </Wrapper>
  );
};

TryAgain.propTypes = {
  padding: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
};

export default TryAgain;
